module.exports = __webpack_public_path__ + "img/新华网_02.ffd482fe.jpg";